module.exports = __webpack_public_path__ + "static/img/oldVersion.c5980622.png";